export function getRequiredStyleTitle (title)  {
  return <><span style={{color: 'red'}}>*</span> {title}</>
}